/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6667 7.33338H3.33333C2.59695 7.33338 2 7.93034 2 8.66672V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V8.66672C14 7.93034 13.403 7.33338 12.6667 7.33338Z"
      stroke="#05034D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66602 7.33323V4.66657C4.66519 3.83993 4.97154 3.04248 5.5256 2.42901C6.07966 1.81555 6.8419 1.42984 7.66435 1.34676C8.4868 1.26368 9.31078 1.48917 9.97633 1.97944C10.6419 2.46972 11.1015 3.1898 11.266 3.9999"
      stroke="#05034D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UnlockIcon = (props) => <Icon component={svg} {...props} />;

export default UnlockIcon;
